import { render } from "./customer.vue?vue&type=template&id=451f548a&scoped=true"
import script from "./customer.vue?vue&type=script&lang=js"
export * from "./customer.vue?vue&type=script&lang=js"

import "./customer.vue?vue&type=style&index=0&id=451f548a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-451f548a"]])

export default __exports__